export default {
  assetsList: [],
  assetReferences: {},
  status: {},
};